import { render, staticRenderFns } from "./club-data.vue?vue&type=template&id=123f7808&scoped=true&"
import script from "./club-data.vue?vue&type=script&lang=js&"
export * from "./club-data.vue?vue&type=script&lang=js&"
import style0 from "./club-data.vue?vue&type=style&index=0&id=123f7808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123f7808",
  null
  
)

export default component.exports